import AttestationDateValid from '@/generated/controls/attestation/AttestationDateValid.vue';
import { defineComponent } from 'vue';

export default defineComponent({
  components: {},
  extends: AttestationDateValid
})
